import { axiosAuthHeader } from "config/axiosConfig";
import api from "../api";

export const deleteDocument = async (docId: number) =>
  api.delete(`/document/${docId}`, { headers: axiosAuthHeader().headers });

export const uploadDocument = async (formdata: FormData, meta: any) => {

    const authheaders = axiosAuthHeader();
    formdata.set('meta', JSON.stringify(meta));
    return api.post(`/document`, formdata, {
        headers: {
            'Content-Type': 'multipart/form-data',
            ...authheaders.headers
        }
    })
        .then(res => {
            return res;
        })
        .catch(e => {
            return e;
        })
}

export const fetchDepositDetails = async (meta: any) => {

    const authheaders = axiosAuthHeader();
    let formdata = new FormData();
    formdata.set('meta', JSON.stringify(meta));
    return api.post(`/document`, formdata, {
        headers: {
            ...authheaders.headers
        }
    })
        .then(res => {
            return res;
        })
        .catch(e => {
            return e;
        })
}

export const getDocuments = async (params: any) => {
    let url = '/document-list';
    if (params) {
        let s = '';
        for (let name in params) {
            s += (s ? '&' : '') + name + '=' + encodeURIComponent(params[name]);
        }
        url += "?" + s;
    }
    return api.get(url, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e => {
            return e;
        })
}

export const getDocumentList = async () => {
    return getDocuments({ latest: "true" });
}

export const getDocumentsByType = async (type: string, params?: any) => {
    return getDocuments(Object.assign({ type }, params));
}

export const getDocument = async (id: string) => {
    return getDocuments({ id })
        .then(res => {
            return res.data?.items ? res.data?.items[0] : undefined;
        })
        .catch(e => {
            return e;
        })
}

export const getDocumentBlob = async (documentId: number) => {
    const authheaders = axiosAuthHeader();
    return api.get(`/document-blob/${documentId}`, {
        responseType: 'blob',
        headers: {
            ...authheaders.headers
        }
    })
        .then(res => {
            return res;
        })
        .catch(e => {
            return e;
        })
}

export const getDocumentSign = async (documentId: number) => {
    const authheaders = axiosAuthHeader();
    return api.get(`/document-blob/${documentId}`, {
        headers: {
            ...authheaders.headers
        }
    })
        .then(res => {
            return res;
        })
        .catch(e => {
            return e;
        })
}
